<div
  class="hover-box"
  [style.left]="left + 'px'"
  [style.top]="top - 195 + 'px'"
>
  <div @fade class="hover-box__hover-text">
    <div class="hover-box__hover-text__date">
      {{ priceGradeData.date }}
    </div>
    <div class="hover-box__hover-text__row">
      <p class="hover-box__hover-text__time-show">
        {{ priceGradeData.time }} {{ priceGradeData.show }}
      </p>
    </div>
    <div class="hover-box__hover-text__price-grade">
      @for (inventory of priceGradeData.priceGradeSeatCounts; track inventory) {
        <div>{{ inventory.seatCount }} {{ inventory.priceGrade }}</div>
      }
    </div>
  </div>
</div>
